import React from "react";

import { TermsAndConditionsTablePage } from "./termsAndConditionsTable/TermsAndConditionsTablePage";
import { TermAndConditionsFilterPage } from "./termsAndConditionsFilter/TermAndConditionsFilterPage";
import classes from "./termsAndConditionsListPage.module.css";

export const TermsAndConditionsListPage = () => {
  return (
    <div className={classes.box}>
      <TermAndConditionsFilterPage />
      <TermsAndConditionsTablePage />
    </div>
  );
};
